import { Box, Button, Text } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledSectionHeader = styled(Text)`
  && {
    color: var(--cl-gray-700);
  }
`;

export const StyledTagDescription = styled(Text)`
  && {
    line-height: var(--cl-font-size-4);
  }
`;

export const StyledEvidencesSection = styled(Box)<{ evaluationExplainability: boolean }>`
  border-top: 1px solid var(--cl-gray-500);
  padding-top: var(--cl-space-5);
  ${({ evaluationExplainability }) => (
    evaluationExplainability && `
      padding-left: calc(26px + var(--cl-space-6));
      padding-right: var(--cl-space-6);
    `
  )}
`;

export const StyledWorkflowCanvasContainer = styled(Box)`
  width: 100%;
  height: 100%;
`;

export const StyledHeader = styled(Box)`
  display: flex;
  width: 96%;
  left: 0px;
`;

export const StyledToggleButton = styled(Button)`
  background-color: transparent;
  width: 10rem;
  display: flex;
  justify-content: flex-start;
`;

export const StyledSearchBoxContainer = styled.div`
  position: absolute;
  top: 73px;
  right: var(--cl-space-8);
`;

export const StyledSearchTriggerContainer = styled.div`
  position: absolute;
  top: var(--cl-space-4);
  right: var(--cl-space-16);
`;
